import { observable } from "mobx";
import { Type } from "class-transformer";
import SystemComponentOutageLocalizationResponse from "./systemComponentOutageLocalizationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SystemComponentOutageResponse {
  /**
   * System component outage ID.
   */
  id!: string;

  /**
   * System component code.
   */
  @observable
  systemComponentCode!: string;

  /**
   * System component outage is supposed to be visible since.
   */
  @observable
  @Type(() => Date)
  visibleSince!: Date;

  /**
   * System component outage valid since.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * System component outage valid until.
   */
  @observable
  @Type(() => Date)
  validUntil?: Date;

  /**
   * System component outage description in default language.
   */
  @observable
  description?: string;

  /**
   * The list of description localizations.
   */
  @observable
  @Type(() => SystemComponentOutageLocalizationResponse)
  localizations!: SystemComponentOutageLocalizationResponse[];
}
